export default (
  canEditEngId: boolean,
  alias: (text: string) => string = (text) => text,
) => [
  {
    field: 'name',
    headerName: alias('Name'),
    description: alias('Name'),
    type: 'string',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: true,
  },
  {
    field: 'engineeringId',
    headerName: alias('Engineering ID'),
    description: alias('Engineering ID'),
    type: 'string',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: canEditEngId,
  },
  {
    field: 'deviceId',
    headerName: alias('Device ID'),
    description: alias('Device ID'),
    type: 'string',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: false,
  },
  {
    field: 'type',
    headerName: alias('Type'),
    description: alias('Type'),
    type: 'string',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: false,
  },
  {
    field: 'parentControllerId',
    headerName: alias('Parent Controller ID'),
    description: alias('Parent Controller ID'),
    type: 'string',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: false,
  },
  {
    field: 'isSiteControllerSourceDevice',
    headerName: alias('Is Site Controller Source Device?'),
    description: alias('Is Site Controller Source Device?'),
    type: 'boolean',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: false,
  },
  {
    field: 'parentSourceDeviceId',
    headerName: alias('Parent Source Device ID'),
    description: alias('Parent Source Device ID'),
    type: 'string',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: false,
  },
];
